export default __webpack_public_path__ + "static/media/linny_kimly_phuong.812c4e0f.jpg";